module.exports = __webpack_public_path__ + "static/img/sadtips.9e38101.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/sadtips.png
// module id = VpP4
// module chunks = 1